import { createRequestAtom } from '../../../../shared/utils/request-atom';
import { MessageInfo } from '../typings/message-types';
import { atom } from 'jotai';

export const messageDetailsAtom = createRequestAtom<MessageInfo['details']>();
export const socketEventReceivedAtom = atom(false);

export const conversationSocketEventAtom = atom<{
  event: string;
  eventPayload?: {
    eventReason?: string;
    chatMessageId?: string;
  };
} | null>(null);
